import { ITypedReduxAction } from '../../../types/redux/actionType';
import { IUserGaData } from '../../../types/analytics';

export enum ESetUserGaDataActionType {
  Set = 'user/setUserGaData/set',
}

export type TUserGaData = ITypedReduxAction<ESetUserGaDataActionType.Set, IUserGaData>;
